import * as React from 'react'

import { observer } from 'mobx-react'

import type { ImportedEmployee } from 'modules/employees/lib/ImportedEmployee'
import CellContent from 'modules/employees/pages/ImportEmployeesPage/components/ImportTable/Content/CellContent'

interface Props {
  employee: ImportedEmployee
  index: number
}

const CustomFieldCellContent = ({ employee, index }: Props) => {
  const errored = employee.status === 'errored'
  const ready = employee.status === 'ready'
  const value = employee.custom_fields[index] ?? ''
  const message = employee.custom_fields_errors[index] ?? ''
  const ok = ready || !message

  return <CellContent value={value} message={message} errored={errored} ok={ok} />
}

export default observer(CustomFieldCellContent)
